rdefine("app/clients/PropertyDisplay",['backbone',
    'text!clients/property.html','app/clients/LanguageForm','text!clients/property-option.html'],function(Backbone, template, LanguageForm, optTemplate) {

    var propertyOptionView = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'property-option-display',
        events:{
            "click .btn-danger":"removeOption"
        },
        initialize:function(options) {
            this.languages = this.model.collection.languages;
            this.$el.html(Template7.compile(optTemplate)({order: this.model.get('order')}));
            this.languagesForm = new LanguageForm({
                el: this.$el.find('.language-place')[0],
                model: this.model,
                field: 'names',
                languages: this.languages
            });
        },
        removeOption: function() {
            this.model.collection.remove(this.model);
        }
    });

    var optionModel = Backbone.Ribs.Model.extend({
        defaults:{
            names:{},
            order:0
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'property-display',
        bindings:{
            '.selectpicker':{
                value:{
                    events: ' change',
                    data:'model.type'
                }
            },
            '.property_required':{
                checked:'model.required'
            },
            '.property_visible':{
                checked:'model.visible'
            },
            '.options-row':{
                toggle:{
                    data:'model.type',
                    processor:function(type) {
                        return type==="select";
                    }
                }
            },
            '.options-row-place':{
                collection:{
                    col:'options',
                    view:propertyOptionView
                }
            }

        },
        events:{
            "click .remove-property":"removeProp",
            "click .add-option":"addOption"
        },
        languages:null,
        options:null,
        initialize:function(options) {
            this.orders = 0;
            this.model.on("change", function(){
                this.model.collection.trigger("change");
            }.bind(this));
            this.options = new Backbone.Ribs.Collection(this.model.get("options"),{ model: optionModel} );
            this.options.languages = this.model.collection.languages;
            this.options.on("add remove change",function(){
                var options = [];
                for(var i=0;i<this.options.length;i++) {
                    options.push(this.options.models[i].attributes);
                }
                this.model.set('options', options);
            }.bind(this));
            this.languages = this.model.collection.languages;
            this.$el.html(Template7.compile(template)({order: this.model.get('order')}));
            this.$el.find(".selectpicker").selectpicker();
            this.languagesForm = new LanguageForm({
                el: this.$el.find('.property-list-names')[0],
                model: this.model,
                field: 'names',
                languages: this.languages
            });
        },
        removeProp: function() {
            this.collection.remove(this.model);
        },
        addOption: function() {
            this.options.add(new optionModel({
                names:{},
                order: this.orders++
            }));
        }
    });
});